module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("80kwo"))).then(() => parcelRequire('d0iPb'));